import { render, staticRenderFns } from "./integralPeopleItemDetail.vue?vue&type=template&id=464cf723&scoped=true&"
import script from "./integralPeopleItemDetail.vue?vue&type=script&lang=js&"
export * from "./integralPeopleItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./integralPeopleItemDetail.vue?vue&type=style&index=0&id=464cf723&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464cf723",
  null
  
)

export default component.exports